import React from "react"
import { createRoot } from "react-dom/client"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { config } from "@fortawesome/fontawesome-svg-core"
import "antd/dist/reset.css"
import App from "./App"
import "./dayjsSetup"
import StagingGateWall from "./components/StagingGateWall"
// Leave this in here, I need do put in the jquery bundle to get "draggable"
// and I want to do it once for the whole repo
// import $ from "jquery"
import "jquery-ui-bundle"
import "jquery-ui-bundle/jquery-ui.min.css"

import "./theme.css"

// Prevent Font Awesome from adding its CSS automatically since we import it above.
config.autoAddCss = false

/*
This is used to turn off all console.logs
function noop() {}

if (process.env.NODE_ENV !== 'development') {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}
*/
const container = document.getElementById("root")
if (container) {
  const root = createRoot(container)
  root.render(
    <StagingGateWall>
      <App />
    </StagingGateWall>,
  )
}
